document.addEventListener('DOMContentLoaded', () => {
  const reveals = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  reveals.forEach(el => observer.observe(el));

  // ==========================================
  // ギャラリー：無限ループ自動スクロール
  // ==========================================
  const gallery = document.querySelector('.solution-gallery');
  if (gallery) {
    const originalItems = [...gallery.querySelectorAll('.solution-gallery-item')];
    const originalCount = originalItems.length;

    // アイテムを複製して無限ループ用に追加
    originalItems.forEach(item => {
      gallery.appendChild(item.cloneNode(true));
    });

    // リセットポイント計算（複製開始位置）
    const allItems = gallery.querySelectorAll('.solution-gallery-item');
    const resetPoint = allItems[originalCount].offsetLeft - allItems[0].offsetLeft;

    let isPaused = false;

    function autoScroll() {
      if (!isPaused) {
        gallery.scrollLeft += 0.5;
        if (gallery.scrollLeft >= resetPoint) {
          gallery.scrollLeft -= resetPoint;
        }
      }
      requestAnimationFrame(autoScroll);
    }

    gallery.addEventListener('mouseenter', () => { isPaused = true; });
    gallery.addEventListener('mouseleave', () => { isPaused = false; });
    gallery.addEventListener('touchstart', () => { isPaused = true; }, { passive: true });
    gallery.addEventListener('touchend', () => {
      setTimeout(() => { isPaused = false; }, 3000);
    });

    // ビューポートに入ったら開始
    const galleryObs = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        autoScroll();
        galleryObs.disconnect();
      }
    }, { threshold: 0.2 });
    galleryObs.observe(gallery);

    // ナビ矢印：スムーズに1カード分スクロール
    function getCardStep() {
      const first = gallery.querySelector('.solution-gallery-item');
      const gap = parseInt(getComputedStyle(gallery).gap) || 20;
      return first.offsetWidth + gap;
    }

    function smoothScrollBy(distance, duration) {
      isPaused = true;
      const start = gallery.scrollLeft;
      const startTime = performance.now();

      function step(now) {
        const progress = Math.min((now - startTime) / duration, 1);
        const ease = 1 - Math.pow(1 - progress, 3);
        gallery.scrollLeft = start + distance * ease;
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          if (gallery.scrollLeft >= resetPoint) gallery.scrollLeft -= resetPoint;
          if (gallery.scrollLeft < 0) gallery.scrollLeft += resetPoint;
          setTimeout(() => { isPaused = false; }, 400);
        }
      }
      requestAnimationFrame(step);
    }

    document.querySelector('.sg-prev').addEventListener('click', () => {
      smoothScrollBy(-getCardStep(), 400);
    });
    document.querySelector('.sg-next').addEventListener('click', () => {
      smoothScrollBy(getCardStep(), 400);
    });
  }

  // ==========================================
  // ライトボックス
  // ==========================================
  const lb = document.getElementById('lightbox');
  if (lb) {
    const lbImg = document.getElementById('lightbox-img');
    const lbCaption = document.getElementById('lightbox-caption');
    const lbCounter = document.getElementById('lightbox-counter');
    const lbOriginals = [...document.querySelectorAll('.solution-gallery-item')].slice(0, 4);
    let lbIndex = 0;

    function lbOpen(index) {
      lbIndex = index;
      const item = lbOriginals[lbIndex];
      if (!item) return;
      lbImg.src = item.querySelector('img').src;
      const captionEl = item.querySelector('.solution-gallery-caption p');
      lbCaption.textContent = captionEl ? captionEl.textContent : '';
      lbCounter.textContent = (lbIndex + 1) + ' / ' + lbOriginals.length;
      lb.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function lbClose() {
      lb.classList.remove('active');
      document.body.style.overflow = '';
    }

    function lbNav(dir) {
      const next = lbIndex + dir;
      if (next >= 0 && next < lbOriginals.length) {
        lbImg.style.opacity = '0';
        setTimeout(() => {
          lbOpen(next);
          lbImg.style.opacity = '1';
        }, 150);
      }
    }

    // イベント委譲：オリジナル＋クローン両方に対応
    if (gallery) {
      gallery.addEventListener('click', (e) => {
        const item = e.target.closest('.solution-gallery-item');
        if (!item) return;
        const allGalleryItems = [...gallery.querySelectorAll('.solution-gallery-item')];
        const clickedIdx = allGalleryItems.indexOf(item);
        lbOpen(clickedIdx % lbOriginals.length);
      });
    }

    document.getElementById('lightbox-close').addEventListener('click', lbClose);
    document.getElementById('lightbox-prev').addEventListener('click', () => lbNav(-1));
    document.getElementById('lightbox-next').addEventListener('click', () => lbNav(1));

    lb.addEventListener('click', (e) => {
      if (e.target === lb) lbClose();
    });

    document.addEventListener('keydown', (e) => {
      if (!lb.classList.contains('active')) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbNav(-1);
      if (e.key === 'ArrowRight') lbNav(1);
    });

    // ライトボックス：スワイプ操作
    let lbTouchX = 0;
    lb.addEventListener('touchstart', (e) => {
      lbTouchX = e.changedTouches[0].screenX;
    }, { passive: true });
    lb.addEventListener('touchend', (e) => {
      const diff = lbTouchX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        lbNav(diff > 0 ? 1 : -1);
      }
    });
  }

  /* --- FAQ Accordion --- */
  window.toggleFaq = function(el) {
    const item = el.parentElement;
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  };

  /* --- Color card thumbnail → main image swap --- */
  document.querySelectorAll('.color-card').forEach(card => {
    const mainWrap = card.querySelector('.color-card-main');
    const mainImg = mainWrap.querySelector('img');
    const thumbs = card.querySelectorAll('.color-card-thumbs img');
    const defaultSrc = mainWrap.dataset.default;
    const defaultStyle = mainWrap.dataset.defaultStyle || '';

    thumbs.forEach(thumb => {
      thumb.addEventListener('mouseenter', () => {
        mainImg.style.cssText = '';
        mainImg.src = thumb.dataset.full;
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });

    card.addEventListener('mouseleave', () => {
      mainImg.src = defaultSrc;
      mainImg.style.cssText = defaultStyle;
      thumbs.forEach(t => t.classList.remove('active'));
    });
  });
});
